import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import { Helmet } from 'react-helmet';

// actions
import { getBeers, getPageBySlug } from '../actions';

// components
import PageHero from '../components/page-hero';
import Button from '../components/common/button';

// images
import actionArrow from '../assets/svg/back-arrow.svg';
import EventList from '../components/event-list';

class HomePage extends Component {
  state = {
    loading: true,
    beers: [],
    data: {}
  };

  componentWillMount() {
    const pageData = Promise.all([getBeers(), getPageBySlug('/home')]);
    pageData.then(data => {
      this.setState({
        loading: false,
        beers: data[0],
        data: data[1]
      });
    });

    window.scrollTo(0, 0);
  }

  nextBeer = () => {
    this.beerSlider.slickNext();
  };

  prevBeer = () => {
    this.beerSlider.slickPrev();
  };

  render() {
    const { beers, loading, data } = this.state,
      page = data.data,
      shuffled = beers.sort(function() {
        return 0.5 - Math.random();
      }),
      beersToRender = shuffled.slice(0, 6);

    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: this.nextBeerBtn,
      prevArrow: this.prevBeerBtn
    };

    if (loading) return null;

    return (
      <main id="home" className="textured">
        <Helmet>
          <title>Baileson Brewing</title>
          <meta name="description" content="Man's other best friend" />
        </Helmet>

        {page && (
          <PageHero image={page.header_image} loading={loading}>
            <Fade bottom cascade>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <h1 className="heading heading--medium beige">
                  {page.header_content}
                </h1>
                {page && page.has_cta && (
                  <div
                    style={{
                      marginTop: '2rem',
                      zIndex: 50,
                      position: 'relative'
                    }}
                  >
                    <Button classes="white" action={page.header_cta_link}>
                      {page.header_cta_text}
                    </Button>
                  </div>
                )}
              </div>
            </Fade>
          </PageHero>
        )}

        {page && (
          <div className="home-content">
            <div className="box title">
              <Fade bottom cascade>
                <h2 className="heading heading--super orange">
                  {page.content_title}
                </h2>
              </Fade>
            </div>

            <div className="box content">
              <div className="text">
                <Fade bottom>
                  <p style={{ marginBottom: '2rem' }}>{page.content}</p>
                  {page.content_has_cta && (
                    <Button type="link" action={page.content_cta_link}>
                      {page.content_cta_text}
                    </Button>
                  )}
                </Fade>
              </div>
            </div>
          </div>
        )}

        <h3 className="heading heading--medium brown the-beer">The Beer</h3>

        <div className="beer-slider">
          <div className="beer-slider__slides">
            <Slider
              settings={sliderSettings}
              ref={beerSlider => (this.beerSlider = beerSlider)}
            >
              {beersToRender.map(beer => (
                <div className="beer-slide" key={beer.id}>
                  <div className="inner-wrapper">
                    <div className="beer-animation">
                      <video playsInline autoPlay loop muted height={444}>
                        <source
                          src={
                            beer.data.beer_gif
                              ? beer.data.beer_gif
                              : 'https://baileson-brewing.flywheelsites.com/wp-content/uploads/2018/09/hazy1.mov'
                          }
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <div className="beer-glass">
                      <div className="beer-detail">
                        <h4 className="beer-name">{beer.data.name}</h4>
                        <div className="beer-style">
                          <p>{beer.data.style}</p>
                        </div>
                      </div>
                      <div className="beer-glass__image">
                        <img src={beer.data.glass_image} alt={beer.data.name} />
                      </div>

                      <Link
                        className="beer-glass__cta"
                        aria-label={`Learn more about ${beer.data.name}`}
                        to={{
                          pathname: `/beer/${beer.slug}`,
                          state: { beer: beer.data }
                        }}
                      >
                        <p>The details</p>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="beer-slider__controls">
            <div className="next-slide">
              <button
                onClick={this.nextBeer}
                aria-label="Next Beer"
                className="beer-btn next"
              >
                <img src={actionArrow} alt="next arrow" />
              </button>
            </div>
            <Button type="link" action="/beers">
              All Beers
            </Button>
            <div className="prev-slide">
              <button
                onClick={this.prevBeer}
                aria-label="Previous Beer"
                className="beer-btn prev"
              >
                <img src={actionArrow} alt="previous arrow" />
              </button>
            </div>
          </div>
        </div>

        {/* <OnTapNow /> */}
        <EventList />
      </main>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage.js